import styled, { css } from 'styled-components';
import Header from 'components/common/Header';
import SensorBox from 'components/service/SensorBox';
import SensorChart from 'components/service/SensorChart';
import Background from 'components/common/Background';
import { useParams, useNavigate } from 'react-router-dom';
import { BsArrowBarLeft } from 'react-icons/bs';
import { getStoreSensorList } from 'lib/api/service/dashboard';
import { useQuery } from 'react-query';
import Loading from 'components/common/Loading';
import ErrorNoti from 'components/common/ErrorNoti';
import useLoginCheck from 'hooks/common/useLoginCheck';
import useCheckAuth from 'hooks/common/useCheckAuth';

const ServiceSensorChartPage = () => {
  const isCheck = useCheckAuth('1');
  const navigate = useNavigate();
  const { id } = useParams();

  const { isLoading, error, data, refetch } = useQuery(['sensorList', id], () =>
    getStoreSensorList(id),
  );
  useLoginCheck(error?.response, refetch);
  const sensorData = data?.data;

  return (
    <ServiceSensorChartPageBlock isCheck={isCheck}>
      <Header service />
      {isLoading || error?.response.status === 401 ? (
        <Loading />
      ) : error?.response.status === 500 ? (
        <ErrorNoti />
      ) : (
        <Background>
          <div className="body">
            <div className="body-header">
              <div className="title">{`온습도 센서 - ${sensorData?.name}`}</div>
              <BsArrowBarLeft
                className="icon"
                onClick={() => navigate('/service')}
              />
            </div>
            <div className="main">
              <SensorBox sensorData={sensorData} />
              <SensorChart />
            </div>
          </div>
        </Background>
      )}
    </ServiceSensorChartPageBlock>
  );
};

export default ServiceSensorChartPage;

const ServiceSensorChartPageBlock = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;

  .body {
    width: 1080px;
    margin: 0 auto;
  }

  .body-header {
    margin-top: 2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .title {
    font-size: 1.3rem;
    font-weight: bold;
    letter-spacing: 4px;
  }

  .icon {
    margin-right: 20px;
    font-size: 1.3rem;
    cursor: pointer;
  }

  .main {
    margin-top: 1rem;
    display: flex;
    justify-content: space-between;
  }

  ${props =>
    !props.isCheck &&
    css`
      visibility: hidden;
    `}
`;
